/**
 * グローバルヘッダ
 */

import clsx from "clsx"
import Logo from "./Logo"
import HeaderContents from "./HeaderContents"
import RegisterDialog from "src/components/common/RegisterDialog"

type Props = {
  isCreatorMyPage?: boolean
}

const GlobalHeader: React.FC<Props> = ({ isCreatorMyPage = false }) => {
  return (
    <>
      <RegisterDialog />
      <header
        className={clsx({
          "global-header": true,
          "-creatorMypage": isCreatorMyPage,
        })}
      >
        <div className="global-header-inner">
          <Logo />
          {/* <SpMenuButton /> */}
          <div className="global-header-contents">
            <HeaderContents />
          </div>
        </div>
      </header>
    </>
  )
}

export default GlobalHeader
